export default __webpack_public_path__ + "static/media/MIS.f25ad848.svg";